// frontend/src/utils/constants.js

export const TIMEFRAMES = [
    { value: '1m', label: '1M', minutes: 1 },
    { value: '5m', label: '5M', minutes: 5 },
    { value: '15m', label: '15M', minutes: 15 },
    { value: '30m', label: '30M', minutes: 30 },
    { value: '1h', label: '1H', minutes: 60 },
    { value: '4h', label: '4H', minutes: 240 },
    { value: '1d', label: '1D', minutes: 1440 },
    { value: '1w', label: '1W', minutes: 10080 }
  ];
  
  export const SIGNAL_TYPES = {
    STRONG_BUY: 'strong_buy',
    BUY: 'buy',
    SELL: 'sell',
    STRONG_SELL: 'strong_sell',
    TAKE_PROFIT: 'take_profit',
    STOP_LOSS: 'stop_loss'
  };
  
  export const SIGNAL_COLORS = {
    [SIGNAL_TYPES.STRONG_BUY]: '#10b981',
    [SIGNAL_TYPES.BUY]: '#34d399',
    [SIGNAL_TYPES.SELL]: '#f87171',
    [SIGNAL_TYPES.STRONG_SELL]: '#ef4444',
    [SIGNAL_TYPES.TAKE_PROFIT]: '#3b82f6',
    [SIGNAL_TYPES.STOP_LOSS]: '#f59e0b'
  };
  
  export const TREND_COLORS = {
    Bullish: '#10b981',
    Bearish: '#ef4444',
    Neutral: '#6b7280'
  };
  
  export const CHART_CONFIG = {
    candleWidth: 0.7,
    volumeHeightRatio: 0.2,
    gridLines: 5,
    colors: {
      bullish: '#10b981',
      bearish: '#ef4444',
      grid: '#e5e7eb',
      text: '#6b7280',
      background: '#ffffff'
    },
    LIGHT_THEME: {
      layout: {
        background: { 
          type: 'solid', 
          color: '#ffffff'
        },
        textColor: '#333333',
      },
      grid: {
        vertLines: { 
          color: '#f0f0f0',
          style: 1,
          visible: true,
        },
        horzLines: { 
          color: '#f0f0f0',
          style: 1,
          visible: true,
        },
      },
      crosshair: {
        mode: 'normal',
        vertLine: {
          width: 1,
          color: '#9B9B9B',
          style: 0,
          labelBackgroundColor: '#616161',
        },
        horzLine: {
          width: 1,
          color: '#9B9B9B',
          style: 0,
          labelBackgroundColor: '#616161',
        },
      },
      rightPriceScale: {
        borderColor: '#e5e7eb',
        autoScale: true,
        alignLabels: true,
        borderVisible: true,
        entireTextOnly: false,
      },
      timeScale: {
        borderColor: '#e5e7eb',
        timeVisible: true,
        secondsVisible: false,
        rightOffset: 12,
        barSpacing: 6,
        minBarSpacing: 0.5,
        fixLeftEdge: false,
        fixRightEdge: false,
        lockVisibleTimeRangeOnResize: false,
        rightBarStaysOnScroll: true,
        borderVisible: true,
        visible: true,
        shiftVisibleRangeOnNewBar: false,
        allowShiftVisibleRangeOnWhitespaceClick: true,
      },
      watermark: {
        visible: true,
        fontSize: 48,
        horzAlign: 'center',
        vertAlign: 'center',
        color: 'rgba(0, 0, 0, 0.05)',
      },
      handleScroll: {
        mouseWheel: true,
        pressedMouseMove: true,
        horzTouchDrag: true,
        vertTouchDrag: true,
      },
      handleScale: {
        axisPressedMouseMove: {
          time: true,
          price: true,
        },
        axisPointTouchDrag: {
          time: true,
          price: true,
        },
        mouseWheel: true,
        pinch: true,
      },
      kineticScroll: {
        touch: true,
        mouse: false,
      },
    }
  };
  
  export const DEFAULT_SETTINGS = {
    sensitivity: 'medium',
    showSignals: true,
    showSupportResistance: true,
    showFairValueGaps: true,
    alertsEnabled: true,
    tradingMode: 'both',
    autoTrade: false,
    riskPerTrade: 2,
    maxOpenTrades: 3
  };
  
  export const POPULAR_SYMBOLS = [
    // Stocks
    { symbol: 'AAPL', name: 'Apple Inc.', type: 'stock' },
    { symbol: 'GOOGL', name: 'Alphabet Inc.', type: 'stock' },
    { symbol: 'MSFT', name: 'Microsoft Corporation', type: 'stock' },
    { symbol: 'AMZN', name: 'Amazon.com Inc.', type: 'stock' },
    { symbol: 'TSLA', name: 'Tesla, Inc.', type: 'stock' },
    { symbol: 'NVDA', name: 'NVIDIA Corporation', type: 'stock' },
    { symbol: 'META', name: 'Meta Platforms Inc.', type: 'stock' },
    
    // Crypto
    { symbol: 'BTC-USD', name: 'Bitcoin USD', type: 'crypto' },
    { symbol: 'ETH-USD', name: 'Ethereum USD', type: 'crypto' },
    { symbol: 'BNB-USD', name: 'Binance Coin USD', type: 'crypto' },
    { symbol: 'SOL-USD', name: 'Solana USD', type: 'crypto' },
    
    // Forex
    { symbol: 'EURUSD=X', name: 'EUR/USD', type: 'forex' },
    { symbol: 'GBPUSD=X', name: 'GBP/USD', type: 'forex' },
    { symbol: 'USDJPY=X', name: 'USD/JPY', type: 'forex' }
  ];
  
  export const INDICATOR_PRESETS = {
    conservative: {
      rsi: { period: 14, overbought: 75, oversold: 25 },
      macd: { fast: 12, slow: 26, signal: 9 },
      sensitivity: 'low'
    },
    balanced: {
      rsi: { period: 14, overbought: 70, oversold: 30 },
      macd: { fast: 12, slow: 26, signal: 9 },
      sensitivity: 'medium'
    },
    aggressive: {
      rsi: { period: 14, overbought: 65, oversold: 35 },
      macd: { fast: 8, slow: 21, signal: 5 },
      sensitivity: 'high'
    }
  };
  
  export const API_ENDPOINTS = {
    MARKET_DATA: '/market',
    INDICATORS: '/indicators',
    SIGNALS: '/signals',
    TICKER_INFO: '/ticker/info',
    SEARCH: '/symbols/search',
    BACKTEST: '/backtest'
  };
  
  export const WS_EVENTS = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    PRICE_UPDATE: 'price_update',
    INDICATOR_UPDATE: 'indicator_update',
    NEW_SIGNAL: 'new_signal',
    MARKET_SNAPSHOT: 'market_snapshot'
  };